import { __decorate } from "tslib";
import { Component, Vue } from "vue-facing-decorator";
let TitlePopUp = class TitlePopUp extends Vue {};
TitlePopUp = __decorate([Component({})], TitlePopUp);
export default TitlePopUp;